import { z } from 'zod';
import { moneySchema } from '@/api/schemas';

export const depositResponseSchema = z.object({
  paymentProviderUrl: z.string(),
});

export const payOverdueResponseSchema = z.object({
  paymentProviderUrl: z.string(),
});

export const getWithdrawalResponseSchema = z.object({
  withdrawnAmount: moneySchema,
  customerCosts: z.object({
    total: moneySchema,
    interest: moneySchema,
    principal: moneySchema,
    outstandingPrincipalBalance: moneySchema,
    totalPayments: z.number(),
    //TODO: Check if this validation can become country specific (FCSE-5955)
    fees: z.object({
      withdrawalFee: z.number().optional(),
      setupFee: z.number().optional(),
      totalInstallmentFees: z.number().optional(),
    }),
  }),
  companyCosts: z.object({
    total: moneySchema,
    funding: moneySchema,
    lossProvision: moneySchema,
    servicing: moneySchema,
    labour: moneySchema,
  }),
  companyProfit: moneySchema,
});

export const withdrawFullAmountResponseSchema = z.object({ transactionId: z.string() });

export const pendingTransactionResponseSchema = z.object({
  data: z.object({
    pendingTransaction: z.boolean(),
    delayed: z.boolean(),
    type: z.string().nullable(),
  }),
});
